import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogActions, MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import { AssignOrdersService } from '../../../services/assigns-orders.service';
import { MatButton } from '@angular/material/button';
import { MessageService } from '../../../services/message.service';
import { LoaderComponent } from '../../loader/loader.component';
import { Order } from '../../../classes/order.class';
import { MatCheckbox } from '@angular/material/checkbox';
import { Person } from '../../../classes/person.class';
import { CloseButtonComponent } from '../../close-button/close-button.component';
import { MatIcon } from '@angular/material/icon';
import { CustomTooltipDirective } from '../../../typing/custom-tooltip.directive';
import {DESCRIPTION_TOOLTIP} from '../assign-orders-form/distribution-tooltips';

@Component({
    selector: 'app-assign-orders-form',
    standalone: true,
    imports: [
        CommonModule,
        MatFormField,
        MatInput,
        MatError,
        FormsModule,
        MatDialogActions,
        MatDialogTitle,
        MatInputModule,
        CustomTooltipDirective,
        MatButton, MatHint, MatLabel, MatDialogContent, LoaderComponent, MatCheckbox, CloseButtonComponent, MatIcon],
    templateUrl: './assign-orders-form.component.html',
    styleUrl: './assign-orders-form.component.scss'
})
export class AssignOrdersFormComponent {
    percentageValue = 1.1;
    balanceWorkload = false;
    assignAllTasks = false;
    assignAllTasksByDuration = false;
    protected assignOrdersService = inject(AssignOrdersService);
    protected dialogRef = inject(MatDialogRef<AssignOrdersFormComponent>);
    public data: { newOrders: Order[], workers: Person[], workerOrdersMap: Map<number, Order[]>} = inject(MAT_DIALOG_DATA);
    protected messagesService = inject(MessageService);
    protected descriptionTooltip = DESCRIPTION_TOOLTIP;
    loading = signal<boolean>(false);

    onSubmit(): void {
        this.loading.set(true);
        this.assignOrdersService.assignTasksToWorkers(
            this.data.newOrders.filter(order => order.data.location),
            this.data.workers, this.data.workerOrdersMap, this.percentageValue,
            this.balanceWorkload, this.assignAllTasks, this.assignAllTasksByDuration)
            .subscribe({
                next: data => this.dialogRef.close(data),
                error: error => {
                    this.messagesService.errorMessage(error.error);
                    this.dialogRef.close();
                }
            }).add(() => this.loading.set(false));
    }
}
